import { Record, Union } from "../../../../src/fable_modules/fable-library.3.7.18/Types.js";
import { record_type, bool_type, union_type, string_type } from "../../../../src/fable_modules/fable-library.3.7.18/Reflection.js";
import { FSharpResult$2 } from "../../../../src/fable_modules/fable-library.3.7.18/Choice.js";
import { isMatch } from "../../../../src/fable_modules/fable-library.3.7.18/RegExp.js";
import { Cmd_none } from "../../../../src/fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { OfAsyncWith_result } from "../../../../src/fable_modules/Fable.Elmish.4.0.0-beta-3/./cmd.obsolete.fs.js";
import { Cmd_OfAsync_start } from "../../../../src/fable_modules/Fable.Elmish.4.0.0-beta-3/./cmd.fs.js";
import { singleton } from "../../../../src/fable_modules/fable-library.3.7.18/AsyncBuilder.js";
import { sleep } from "../../../../src/fable_modules/fable-library.3.7.18/Async.js";
import { StyleCreator$1_$ctor, StyleImports_makeStyles_get } from "../../../../../src/Feliz.MaterialUI/./Styles.fs.js";
import { StyleCreator$1__create_4EAC9E1E } from "../../../../../src/Feliz.MaterialUI/Styles.fs.js";
import { singleton as singleton_1, ofArray } from "../../../../src/fable_modules/fable-library.3.7.18/List.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../../../../src/fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";
import { MuiHelpers_createElement } from "../../../../../src/Feliz.MaterialUI/./Mui.fs.js";
import { Link, Grid, Button, Checkbox, FormControlLabel, TextField, Typography, Avatar, CircularProgress, Container } from "@mui/material";
import { createElement } from "react";
import * as react from "react";
import { createObj } from "../../../../src/fable_modules/fable-library.3.7.18/Util.js";
import { empty, singleton as singleton_2, append, delay, toList } from "../../../../src/fable_modules/fable-library.3.7.18/Seq.js";
import LockOutlined from "@mui/icons-material/LockOutlined";
import { Interop_reactApi } from "../../../../src/fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { Browser_Types_Event__Event_get_Checked, Browser_Types_Event__Event_get_Value } from "../../../../../src/Feliz.MaterialUI/../../docs-app/src/fable_modules/Fable.React.8.0.1/Fable.React.Extensions.fs.js";

export class Domain_ValidEmail extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ValidEmail"];
    }
}

export function Domain_ValidEmail$reflection() {
    return union_type("Samples.Samples.SignIn.SignIn.Domain.ValidEmail", [], Domain_ValidEmail, () => [[["Item", string_type]]]);
}

export function Domain_ValidEmail_Create_Z721C83C5(s) {
    if (s === "") {
        return new FSharpResult$2(1, "Required");
    }
    else if (!isMatch(/\w+@\w+\.\w+/gu, s)) {
        return new FSharpResult$2(1, "Enter a valid email address");
    }
    else {
        return new FSharpResult$2(0, new Domain_ValidEmail(0, s));
    }
}

export class Domain_ValidPassword extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ValidPassword"];
    }
}

export function Domain_ValidPassword$reflection() {
    return union_type("Samples.Samples.SignIn.SignIn.Domain.ValidPassword", [], Domain_ValidPassword, () => [[["Item", string_type]]]);
}

export function Domain_ValidPassword_Create_Z721C83C5(s) {
    if (s === "") {
        return new FSharpResult$2(1, "Required");
    }
    else {
        return new FSharpResult$2(0, new Domain_ValidPassword(0, s));
    }
}

export class Domain_SubmitData extends Record {
    constructor(Email, Password, RememberMe) {
        super();
        this.Email = Email;
        this.Password = Password;
        this.RememberMe = RememberMe;
    }
}

export function Domain_SubmitData$reflection() {
    return record_type("Samples.Samples.SignIn.SignIn.Domain.SubmitData", [], Domain_SubmitData, () => [["Email", Domain_ValidEmail$reflection()], ["Password", Domain_ValidPassword$reflection()], ["RememberMe", bool_type]]);
}

export class Model extends Record {
    constructor(EmailAddress, ValidateEmailAddress, Password, ValidatePassword, RememberMe, IsBusy) {
        super();
        this.EmailAddress = EmailAddress;
        this.ValidateEmailAddress = ValidateEmailAddress;
        this.Password = Password;
        this.ValidatePassword = ValidatePassword;
        this.RememberMe = RememberMe;
        this.IsBusy = IsBusy;
    }
}

export function Model$reflection() {
    return record_type("Samples.Samples.SignIn.SignIn.Model", [], Model, () => [["EmailAddress", string_type], ["ValidateEmailAddress", bool_type], ["Password", string_type], ["ValidatePassword", bool_type], ["RememberMe", bool_type], ["IsBusy", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetEmailAddress", "EnableValidateEmailAddress", "SetPassword", "EnableValidatePassword", "SetRememberMe", "SubmitInvalid", "SubmitValid", "SignInCompleted"];
    }
}

export function Msg$reflection() {
    return union_type("Samples.Samples.SignIn.SignIn.Msg", [], Msg, () => [[["Item", string_type]], [], [["Item", string_type]], [], [["Item", bool_type]], [], [["Item", Domain_SubmitData$reflection()]], []]);
}

export const init = new Model("", false, "", false, false, false);

export function update(msg, m) {
    if (msg.tag === 1) {
        return [new Model(m.EmailAddress, true, m.Password, m.ValidatePassword, m.RememberMe, m.IsBusy), Cmd_none()];
    }
    else if (msg.tag === 2) {
        return [new Model(m.EmailAddress, m.ValidateEmailAddress, msg.fields[0], m.ValidatePassword, m.RememberMe, m.IsBusy), Cmd_none()];
    }
    else if (msg.tag === 3) {
        return [new Model(m.EmailAddress, m.ValidateEmailAddress, m.Password, true, m.RememberMe, m.IsBusy), Cmd_none()];
    }
    else if (msg.tag === 4) {
        return [new Model(m.EmailAddress, m.ValidateEmailAddress, m.Password, m.ValidatePassword, msg.fields[0], m.IsBusy), Cmd_none()];
    }
    else if (msg.tag === 5) {
        return [new Model(m.EmailAddress, true, m.Password, true, m.RememberMe, m.IsBusy), Cmd_none()];
    }
    else if (msg.tag === 6) {
        if (m.IsBusy) {
            return [m, Cmd_none()];
        }
        else {
            return [new Model(m.EmailAddress, m.ValidateEmailAddress, m.Password, m.ValidatePassword, m.RememberMe, true), OfAsyncWith_result((x) => {
                Cmd_OfAsync_start(x);
            }, singleton.Delay(() => singleton.Bind(sleep(1000), () => singleton.Return(new Msg(7)))))];
        }
    }
    else if (msg.tag === 7) {
        return [new Model(m.EmailAddress, m.ValidateEmailAddress, m.Password, m.ValidatePassword, m.RememberMe, false), Cmd_none()];
    }
    else {
        return [new Model(msg.fields[0], m.ValidateEmailAddress, m.Password, m.ValidatePassword, m.RememberMe, m.IsBusy), Cmd_none()];
    }
}

export const useStyles = StyleImports_makeStyles_get((() => {
    let f1;
    const styles = StyleCreator$1_$ctor();
    f1 = ((theme) => {
        const paper = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["marginTop", theme.spacing(8)], ["display", "flex"], ["flexDirection", "column"], ["alignItems", "center"]]));
        const progressBar = StyleCreator$1__create_4EAC9E1E(styles, singleton_1(["margin", theme.spacing(1)]));
        return {
            avatar: StyleCreator$1__create_4EAC9E1E(styles, ofArray([["margin", theme.spacing(1)], ["backgroundColor", theme.palette.primary.main]])),
            form: StyleCreator$1__create_4EAC9E1E(styles, ofArray([["width", 100 + "%"], ["marginTop", theme.spacing(1)]])),
            paper: paper,
            progressBar: progressBar,
            submit: StyleCreator$1__create_4EAC9E1E(styles, singleton_1(["margin", theme.spacing(3, 0, 2)])),
        };
    });
    return (arg) => {
        const o = f1(arg);
        return Object.assign({}, o);
    };
})());

export function SignIn(signInInputProps) {
    let elements_4, elems_5;
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(() => [init, Cmd_none()], update, [signInInputProps.$key]);
    const model = patternInput[0];
    const dispatch = patternInput[1];
    const classes = useStyles();
    return MuiHelpers_createElement(Container, [["component", "main"], ["maxWidth", "xs"], (elements_4 = [createElement("div", createObj(ofArray([["className", classes.paper], (elems_5 = toList(delay(() => {
        let elements, props_2;
        return append(model.IsBusy ? singleton_2(MuiHelpers_createElement(CircularProgress, [["color", "secondary"]])) : singleton_2(MuiHelpers_createElement(Avatar, [(elements = [(props_2 = {}, react.createElement(LockOutlined, props_2))], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])), delay(() => append(singleton_2(MuiHelpers_createElement(Typography, [["component", "h1"], ["variant", "h5"], ["children", "Sign in"]])), delay(() => {
            let elems_4, elements_3, elements_1, elements_2;
            return singleton_2(createElement("form", createObj(ofArray([["className", classes.form], (elems_4 = [MuiHelpers_createElement(TextField, toList(delay(() => append(singleton_2(["value", model.EmailAddress]), delay(() => append(singleton_2(["onChange", (e) => {
                dispatch(new Msg(0, Browser_Types_Event__Event_get_Value(e)));
            }]), delay(() => append(singleton_2(["variant", "outlined"]), delay(() => append(singleton_2(["margin", "normal"]), delay(() => append(singleton_2(["required", true]), delay(() => append(singleton_2(["fullWidth", true]), delay(() => append(singleton_2(["id", "email"]), delay(() => append(singleton_2(["label", "Email Address"]), delay(() => append(singleton_2(["name", "email"]), delay(() => append(singleton_2(["autoComplete", "email"]), delay(() => append(singleton_2(["autoFocus", true]), delay(() => append(singleton_2(["onBlur", (_arg) => {
                dispatch(new Msg(1));
            }]), delay(() => {
                const matchValue = [model.ValidateEmailAddress, Domain_ValidEmail_Create_Z721C83C5(model.EmailAddress)];
                let pattern_matching_result, err;
                if (matchValue[0]) {
                    const copyOfStruct = matchValue[1];
                    if (copyOfStruct.tag === 1) {
                        pattern_matching_result = 1;
                        err = copyOfStruct.fields[0];
                    }
                    else {
                        pattern_matching_result = 0;
                    }
                }
                else {
                    pattern_matching_result = 0;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return empty();
                    }
                    case 1: {
                        return append(singleton_2(["error", true]), delay(() => singleton_2(["helperText", err])));
                    }
                }
            }))))))))))))))))))))))))))), MuiHelpers_createElement(TextField, toList(delay(() => append(singleton_2(["value", model.Password]), delay(() => append(singleton_2(["onChange", (e_1) => {
                dispatch(new Msg(2, Browser_Types_Event__Event_get_Value(e_1)));
            }]), delay(() => append(singleton_2(["variant", "outlined"]), delay(() => append(singleton_2(["margin", "normal"]), delay(() => append(singleton_2(["required", true]), delay(() => append(singleton_2(["fullWidth", true]), delay(() => append(singleton_2(["id", "password"]), delay(() => append(singleton_2(["label", "Password"]), delay(() => append(singleton_2(["name", "password"]), delay(() => append(singleton_2(["type", "password"]), delay(() => append(singleton_2(["autoComplete", "current-password"]), delay(() => append(singleton_2(["onBlur", (_arg_1) => {
                dispatch(new Msg(3));
            }]), delay(() => {
                const matchValue_1 = [model.ValidatePassword, Domain_ValidPassword_Create_Z721C83C5(model.Password)];
                let pattern_matching_result_1, err_1;
                if (matchValue_1[0]) {
                    const copyOfStruct_1 = matchValue_1[1];
                    if (copyOfStruct_1.tag === 1) {
                        pattern_matching_result_1 = 1;
                        err_1 = copyOfStruct_1.fields[0];
                    }
                    else {
                        pattern_matching_result_1 = 0;
                    }
                }
                else {
                    pattern_matching_result_1 = 0;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        return empty();
                    }
                    case 1: {
                        return append(singleton_2(["error", true]), delay(() => singleton_2(["helperText", err_1])));
                    }
                }
            }))))))))))))))))))))))))))), MuiHelpers_createElement(FormControlLabel, [["label", "Remember me"], ["control", MuiHelpers_createElement(Checkbox, [["checked", model.RememberMe], ["onChange", (e_2) => {
                dispatch(new Msg(4, Browser_Types_Event__Event_get_Checked(e_2)));
            }], ["value", "remember"], ["color", "primary"]])]]), MuiHelpers_createElement(Button, [["type", "submit"], ["fullWidth", true], ["variant", "contained"], ["color", "primary"], ["children", "Sign In"], ["disabled", model.IsBusy], ["onClick", (e_3) => {
                e_3.preventDefault();
                const matchValue_2 = [Domain_ValidEmail_Create_Z721C83C5(model.EmailAddress), Domain_ValidPassword_Create_Z721C83C5(model.Password)];
                let pattern_matching_result_2, e_4, p;
                const copyOfStruct_2 = matchValue_2[0];
                if (copyOfStruct_2.tag === 0) {
                    const copyOfStruct_3 = matchValue_2[1];
                    if (copyOfStruct_3.tag === 0) {
                        pattern_matching_result_2 = 0;
                        e_4 = copyOfStruct_2.fields[0];
                        p = copyOfStruct_3.fields[0];
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                }
                else {
                    pattern_matching_result_2 = 1;
                }
                switch (pattern_matching_result_2) {
                    case 0: {
                        dispatch(new Msg(6, new Domain_SubmitData(e_4, p, model.RememberMe)));
                        break;
                    }
                    case 1: {
                        dispatch(new Msg(5));
                        break;
                    }
                }
            }]]), MuiHelpers_createElement(Grid, [["container", true], ["sx", {
                justifyContent: "space-between",
            }], (elements_3 = [MuiHelpers_createElement(Grid, [["item", true], ["xs", "auto"], (elements_1 = [MuiHelpers_createElement(Link, [["href", "#"], ["variant", "body2"], ["children", "Forgot password?"], ["onClick", (e_5) => {
                e_5.preventDefault();
            }]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(Grid, [["item", true], (elements_2 = [MuiHelpers_createElement(Link, [["href", "#"], ["variant", "body2"], ["children", "Don\u0027t have an account? Sign Up"], ["onClick", (e_6) => {
                e_6.preventDefault();
            }]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]))));
        }))));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])]);
}

